import React from 'react';
import Markdown from 'markdown-to-jsx';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Box, Stack } from '@atlaskit/primitives';
import {
	srcDark as srcGenericErrorDark,
	srcLight as srcGenericErrorLight,
} from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/generic-error/index.tsx';
import {
	srcDark as srcDarkComplexWindow,
	srcLight as srcLightComplexWindow,
} from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/complex-window/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { Anchor } from '../../../common/ui/anchor/index.tsx';
import { TransitionHomeContentBox } from '../../../common/ui/transition-home/content-box/index.tsx';
import { TransitionHomeHeader } from '../../../common/ui/transition-home/header/index.tsx';
import { messages as stepMessages } from '../../../common/ui/transition-home/step/messages.tsx';
import taskMessages from '../../../common/utils/tasks/messages.tsx';
import { useGlobalChangeboarding } from '../../../controllers/store/global/index.tsx';
import { messages } from './messages.tsx';

export const AutomateAlertAndIncidentResponseStep = () => {
	const { formatMessage } = useIntl();

	const isPrimaryAdmin = useIsAdmin();
	const isSiteAdmin = useIsSiteAdmin();

	const { opsgenieBaseUrl } = useGlobalChangeboarding();

	const ogTeamsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/teams/list` : '';

	return (
		<Stack space="space.250">
			<TransitionHomeHeader
				title={formatMessage(stepMessages.automateAlertAndIncidentResponseTitleNonFinal)}
				description={formatMessage(
					stepMessages.automateAlertAndIncidentResponseDescriptionNonFinal,
				)}
			/>
			{/* Task One */}
			<TransitionHomeContentBox
				illustration={
					<Image width="200px" src={srcLightComplexWindow} srcDark={srcDarkComplexWindow} alt="" />
				}
			>
				<Stack space="space.200">
					<Heading as="h2" size="small">
						{formatMessage(taskMessages.automateAlertsAndIncidentResponseTaskOneNonFinal)}
					</Heading>
					<Box>
						<Markdown options={{ overrides: { a: { component: Anchor } } }}>
							{formatMessage(messages.taskOneDescriptionNonFinal)}
						</Markdown>
					</Box>
					{(isPrimaryAdmin || isSiteAdmin) && (
						<Box>
							<Button href="/jira/settings/automation" target="_blank">
								{formatMessage(messages.taskOneButtonNonFinal)}
							</Button>
						</Box>
					)}
				</Stack>
			</TransitionHomeContentBox>

			{/* Task Two */}
			<TransitionHomeContentBox
				illustration={
					<Image width="163px" src={srcGenericErrorLight} srcDark={srcGenericErrorDark} alt="" />
				}
			>
				<Stack space="space.200">
					<Heading as="h2" size="small">
						{formatMessage(taskMessages.automateAlertsAndIncidentResponseTaskTwoNonFinal)}
					</Heading>
					<Stack space="space.150">
						<Markdown options={{ overrides: { a: { component: Anchor } } }}>
							{formatMessage(messages.taskTwoDescriptionNonFinal)}
						</Markdown>
					</Stack>
					<Box>
						<Button href={ogTeamsUrl} target="_blank">
							{formatMessage(messages.taskTwoButtonNonFinal)}
						</Button>
					</Box>
				</Stack>
			</TransitionHomeContentBox>
		</Stack>
	);
};
